import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';

import { EnvironmentConst } from '../../constants/Environment.const';
import * as _ from 'lodash';
// import { VideoDuration } from '../../constants/VideoDuration.const';
import { DigitalPlanConfigVO } from 'src/app/planner/interfaces/vo/DigitalPlanConfigVO';

@Component({
	selector: 'digital-video-format-settings',
	templateUrl: './digital-video-format-settings.component.html',
	styleUrls: ['./digital-video-format-settings.component.scss']
})
export class DigitalVideoFormatSettingsComponent implements OnInit {

	@Input() group: FormGroup;
	@Input() isNew: boolean;
	@Input() hasDefaults: boolean;
	@Input() advertiserInfo: any;
	@Input() digitalVideoVO: DigitalPlanConfigVO;
	@Input() status: string;

	// Not supported for V1 as per [CSYS-5054]
	// videoDurationConst = VideoDuration;
	environments: Array<any> = [];
	dropdownSettings: any;
	selectedItems: Array<any> = [];
	selectedEnv: Array<any> = [];

	constructor() { }

	ngOnInit() {

		this.mapEnvironmentData();
		this.dropdownSettings = {
			singleSelection: false,
			defaultOpen: false,
			idField: 'id',
			textField: 'text',
			enableCheckAll: false,
			allowSearchFilter: false,
			showChipsInsideDropdown: true
		};
	}

	onItemSelect(item: any) {
		this.environment.patchValue(_.map(this.selectedEnv, 'id'));
	}

	mapEnvironmentData() {
		let selectedEnvIds = ((this.tactics.controls[0]) as FormGroup).controls.environments.value;
		_.forEach(EnvironmentConst, (value: any, key: string) => {
			this.environments.push({
				id: value.id,
				text: key
			});
		});

		this.selectedEnv = _.filter(this.environments, (env: any) => {
			return selectedEnvIds.findIndex((o: any) => { return o === env.id }) > -1;
		});
	}

	get tactics() {
		return this.group.get('tactics') as FormArray;
	}

	get environment(): FormControl {
		return ((this.tactics.controls[0]) as FormGroup).controls.environments as FormControl;
	}

	get isDisabled(): boolean {
		return this.environment.disabled;
	}
}
